import * as yup from 'yup'
import i18n from '@/localization/i18n'
import constants from '@/utils/constants'
import { isLocalhost } from '@/utils/functions'

const t = i18n.global.t
const isCaptchaRequired = !isLocalhost()
const phoneRegex = /^(06|07)[0-9]{8}$/

export const schemaValidator = (isFinal: boolean = true) => {
    return yup.object().shape({
        email: isFinal ? yup.string()
            .matches(constants.EMAIL_REGEX, t('w_msg_frmVal_emailFormat'))
            .required(t('w_msg_frmVal_required')) : yup.string()
                .required(t('w_msg_frmVal_required')),
        first_name: yup.string()
            .max(150, t('w_msg_frmVal_maxCharacters', 150))
            .required(t('w_msg_frmVal_required')),
        last_name: yup.string()
            .max(150, t('w_msg_frmVal_maxCharacters', 150))
            .required(t('w_msg_frmVal_required')),
        phone: yup.string()
            .matches(phoneRegex, t('w_msg_frmVal_phoneFormat'))
            .max(10, t('w_msg_frmVal_maxCharacters', { num: 10 }))
            .required(t('w_msg_frmVal_required')),
        terms: yup.boolean()
            .oneOf([true], t('w_msg_frmVal_requiredTerms')),
        cloudflare_captcha_token: isCaptchaRequired
            ? yup.string().required(t('w_msg_frmVal_requiredCaptcha'))
            : yup.string().notRequired(),
    })
}

export const businessRequestSignUpSchema = schemaValidator()



